module.exports = __webpack_public_path__ + "img/whatsapp.19685744.png";